import * as Factory from 'factory.ts'
import { User } from '../models/User'
import { faker } from '@faker-js/faker'

export const userFactory = Factory.Sync.makeFactory<User>({
  id: Factory.each((i) => i),
  name: Factory.each(() => faker.person.fullName()),
  email: Factory.each(() => faker.internet.email()),
  phone: Factory.each(() => faker.phone.number()),
})
